import LeaderboardPlayer from '@Leaderboards/LeaderboardPlayer';

class LeaderboardEntry implements Networks.LeaderboardEntry {

    private score: number;

    private formattedScore: string;

    private timestamp: number;

    private rank: number;

    private extraData: string;

    private player: Networks.LeaderboardPlayer;

    /**
     * Constructor
     */
    constructor(leaderboardData: LeaderboardEntryExportDataObject)
    {
        this.rank = leaderboardData.rank;
        this.score = leaderboardData.score;
        this.timestamp = leaderboardData.timestamp;
        this.extraData = leaderboardData.extraData;
        this.formattedScore = leaderboardData.formattedScore;
        this.player = new LeaderboardPlayer(leaderboardData.player)
    }

    /**
     * Gets the score associated with the entry.
     * @returns Returns an integer score value.
     */
    public getScore(): number
    {
        return this.score;
    }

    /**
     * Gets the score associated with the entry, formatted with the score format associated with the leaderboard.
     * @returns Returns a formatted score.
     */
    public getFormattedScore(): string
    {
        return this.formattedScore;
    }

    /**
     * Gets the timestamp of when the leaderboard entry was last updated.
     * @returns Returns a Unix timestamp.
     */
    public getTimestamp(): number
    {
        return this.timestamp;
    }

    /**
     * Gets the rank of the player's score in the leaderboard
     * @returns Returns the entry's leaderboard ranking.
     */
    public getRank(): number
    {
        return this.rank;
    }

    /**
     * Gets the developer-specified payload associated with the score, or null if one was not set.
     * @returns An optional developer-specified payload associated with the score.
     */
    public getExtraData(): string | null
    {
        return this.extraData;
    }

    /**
     * Gets information about the player associated with the entry.
     */
    public getPlayer(): Networks.LeaderboardPlayer
    {
        return this.player;
    }


    public static export(leaderboardEntry: Networks.LeaderboardEntry)
    {
        return {
            score: leaderboardEntry.getScore(),
            formattedScore: leaderboardEntry.getFormattedScore(),
            rank: leaderboardEntry.getRank(),
            timestamp: leaderboardEntry.getTimestamp(),
            extraData: leaderboardEntry.getExtraData(),
            player: LeaderboardPlayer.export(leaderboardEntry.getPlayer())
        };
    }
}

export default LeaderboardEntry;



/*------------------------ Interfaces -------------------------*/

export interface LeaderboardEntryExportDataObject
{
    score: number,
    formattedScore: string,
    rank: number,
    timestamp: number,
    extraData: string
    player:{
        id: string,
        name: string,
        photo: string
    }
}